import React from "react";
import SEO from "../../SEO";
import { useCanonicalUrl } from "../../useCanonicalUrl";

const Feedback = () => {
  const canonical = useCanonicalUrl();
  return (
    <>
      <SEO
        title="Feedback – Trust Doc"
        description="Share your feedback with Trust Doc."
       canonical={canonical}
      />

      <div className="feedback-page">
        {/* Header Section */}
        <header className="feedback-header">
          <h1>Send Us Feedback</h1>
          <p>
            Your feedback helps us improve. Please share your thoughts and
            suggestions below.
          </p>
        </header>

        {/* Feedback Form Card */}
        <section className="feedback-card">
          <textarea
            className="feedback-textarea"
            rows="6"
            placeholder="Type your feedback here..."
          ></textarea>

          <button className="feedback-button">Submit Feedback</button>
        </section>

        {/* Styles */}
        <style>{`
        .feedback-page {
          min-height: 100vh;
          background: linear-gradient(to bottom right, #f0f9ff, #ffffff, #e0f2fe);
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-bottom: 4rem;
        }

        .feedback-header {
          width: 100%;
          background-color: #0369a1;
          color: white;
          text-align: center;
          padding: 1rem;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
        }

        .feedback-header h1 {
          font-size: 2.5rem;
          font-weight: 800;
          margin-bottom: 1rem;
        }

        .feedback-header p {
          max-width: 700px;
          margin: 0 auto;
          font-size: 1.1rem;
          font-weight: 300;
          opacity: 0.9;
        }

        .feedback-card {
          max-width: 700px;
          width: 100%;
          background: white;
          margin-top: 3rem;
          padding: 2.5rem 3rem;
          border-radius: 1.2rem;
          box-shadow: 0 8px 20px rgba(0,0,0,0.08);
          border: 1px solid #f3f4f6;
          display: flex;
          flex-direction: column;
        }

        .feedback-textarea {
          width: 100%;
          resize: vertical;
          padding: 1rem;
          border-radius: 8px;
          border: 1px solid #cbd5e1;
          font-size: 1rem;
          font-family: inherit;
          margin-bottom: 1.5rem;
          outline: none;
          transition: border 0.2s, box-shadow 0.2s;
        }

        .feedback-textarea:focus {
          border-color: #0369a1;
          box-shadow: 0 0 0 3px rgba(3,105,161,0.15);
        }

        .feedback-button {
          background-color: #0369a1;
          color: white;
          padding: 0.8rem 1.4rem;
          font-size: 1rem;
          font-weight: 500;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          align-self: flex-start;
          transition: background-color 0.2s;
        }

        .feedback-button:hover {
          background-color: #025986;
        }

        @media (max-width: 600px) {
          .feedback-card {
            padding: 2rem;
          }

          .feedback-header h1 {
            font-size: 2rem;
          }
        }
      `}</style>
      </div>
    </>
  );
};

export default Feedback;
